import angular from 'angular';
import { AddressFormComponent } from './form.component';
import { EmptyStringToNullDirective } from './empty-string-to-null.directive';
import { ZipCodeValidator } from '../../src/validators';
import { ChangeModule } from '../../src/helpers/u-change';

export const AddressFormModule = angular
  .module('angular-common.address.form', [
    EmptyStringToNullDirective.name,
    ZipCodeValidator.name,
    ChangeModule.name,
  ])
  .component('updAddressForm', AddressFormComponent);
